import { createStyles, makeStyles } from "@mui/styles";
import customColors from "../../../styles/coreStyles/ColorPalette";
import customFonts from "../../../styles/coreStyles/Fonts";

export const useStyles = makeStyles(() =>
  createStyles({
    boxContainer: {
      margin: 0,
      padding: 0,
    },
    contentContainer: {
      padding: "5px",
      paddingTop: "10px",
      border: "5px solid " + customColors.groupBlue,
      // borderRadius: "10px", // Yuvarlak köşeler için
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Hafif bir gölge ekler
      backgroundColor: "#f5f5f5", // Hafif gri bir arka plan rengi
      "& span": {
        fontFamily: customFonts.regularFont,
        fontSize: "14px", // Font boyutunu ayarlama
        fontWeight: "400", // Font kalınlığını ayarlama
        lineHeight: "1.6", // Satır yüksekliğini ayarlama
      },
    },
    popperDimensions: {
      // padding: "1px",
      width: "250px",
    },
    filterTitleSpacing: {
      marginTop: "5px",
      // marginBottom: "15px",
      background: customColors.groupBlue,
      color: "white",
      fontFamily: customFonts.regularFont,
      padding: "5px",
      alignSelf: "center",
      textAlign: "center", // Centers the text horizontally
      display: "flex", // Makes use of Flexbox
      justifyContent: "center", // Centers the content (including text and other elements) horizontally if needed
      alignItems: "center", // Centers the content vertically if the element's height is defined
    },
    filterStatusSpacing: {
      marginBottom: "7px",
      fontFamily: customFonts.regularFont,
    },
  })
);

export const textColor = {
  color: "rgb(255, 255, 255)",
};

export const overlayIndex = {
  zIndex: 2,
};
